import React, {Fragment, Suspense} from 'react';
import requestApi from "../../../../services/requestApi.service";
import InboxSettingsItem from "../../Whatsapp/InboxSettingsItem";
import NotificationItem from "./NotificationItem";
import {getSessionValue, showToast, decodeString, getWATemplateDetails} from "../../../../Common/Appcommon";

class Notification extends React.Component{
    templateFormname = process.env.REACT_APP_TEMPLATES_FORMNAME;
    leadFormname = getSessionValue('leadformname');
    constructor(props) {
        super(props);

        this.state = {
            notifications : [],
            showLoader : false,
            waTemplates : {},
            waOptions : [],
        }
    }

    componentDidMount = async () => {
        this.setState({
            showLoader : true
        })
        await this.loadWhatsAppNotifications();
        let waTempDetails = await getWATemplateDetails("waNotification");
        let waTemplates = {};
        let waOptions = [];
        if(waTempDetails.length > 0){
            waTemplates = waTempDetails[0];
            waOptions = waTempDetails[1];
        }
        this.setState({
            showLoader : false,
            waTemplates, waOptions
        })

    }

    loadWhatsAppNotifications = async () => {
        let params = {
            "ENTITY": "NEWTRIGGER_ENTITY",
            "OPERATION": "GETALL",
            "MODULENAME" : "WA_NOTIFICATIONS",
            "FORMNAME" : this.leadFormname
        };

        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let notificationData = response.data;
            this.setState({
                notifications : notificationData
            })
        }
    }

    

    render() {
        let {notifications, waOptions, waTemplates} = this.state;
        return (
            <>
                <Fragment>
                    <div className={'notifications-container kv-main-wrapper h100per w-100'}>
                        <div className={'notification-list-container'}>
                            <div id="accordion" className="accordion-wrapper mb-3">
                                {
                                    notifications.length > 0 && Object.keys(waTemplates).length > 0 && notifications.map((notification, index) => {
                                        return (
                                            <NotificationItem waOptions={waOptions} waTemplates={waTemplates} notification={notification} />
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </Fragment>
            </>
        )
    }
}

export default Notification;
